import React from 'react'

const OffWrap = () => {

	const canvasMenuRemove = () => {
        document.body.classList.remove('nav-expanded');
    };

	return (
        <div onClick={canvasMenuRemove} className='offwrap'>

        </div>
    );
}

export default OffWrap;